import Table from "../../components/Table";
import { useColumns } from "./useColumns";

function UserColumnsList() {
    const columns = useColumns();

    return (
        <Table
            columns={columns}
            fieldName="columns"
            isFilter
        />
    );
}

export default UserColumnsList;
